var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[_c('HintLabels',{staticClass:"absolute bg-white bottom-0 left-4 z-50 p-2 rounded-md shadow-md",attrs:{"colors":_vm.colors,"labels":_vm.anomalyTypes}}),_c('div',{ref:"mapElement",attrs:{"id":"map"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }